import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-exhibit-detail-dialog',
  templateUrl: './manual-exhibit-detail-dialog.component.html',
  styleUrls: ['./manual-exhibit-detail-dialog.component.css'],
  standalone: false,
})
export class ManualExhibitDetailDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly nameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_NAME_DIALOG;
  readonly descDialogLink: string = AppConst.ROUTING_LINK_MANUAL_DESC_DIALOG;
  readonly uploaderLink: string = AppConst.ROUTING_LINK_MANUAL_UPLOADER;
  readonly exhibitDetailAttributeDialogLink: string = AppConst.ROUTING_LINK_MANUAL_EXHIBIT_DETAIL_ATTRIBUTE_DIALOG;
  readonly youtubeDialogLink: string = AppConst.ROUTING_LINK_MANUAL_YOUTUBE_DIALOG;
  readonly urlDialogLink: string = AppConst.ROUTING_LINK_MANUAL_URL_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
